import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ValidatorService } from '@capturum/ui/api';

@Injectable()
export class CapturumHttpCodeInterceptor implements HttpInterceptor {
  constructor(private readonly validatorService: ValidatorService) {}

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap(
        () => {
          return null;
        },
        (error: any) => {
          if (error instanceof HttpErrorResponse) {
            switch (error.status) {
              case 400:
              case 403:
              case 422:
              case 401:
                this.parseValidations(error.error);

                break;
              default:
                break;
            }
          }
        },
      ),
    );
  }

  protected parseValidations(response: { errors: Record<string, string[]>; message: string }): void {
    const keys = response.errors && Object.keys(response.errors);

    if (keys && keys.length) {
      const fieldErrors = keys.reduce((accumulator, key) => {
        return { ...accumulator, [key]: response.errors[key] };
      }, {});

      this.validatorService.backendValidation.next(fieldErrors);
    }
  }
}
